<template html="lang">
  <transition name="fade">
    <div class="popup-msg" v-bind:class="type" v-show="visible">
      <span class="btn-close" @click="closePopupMsg()"><i class="fa fa-times" aria-hidden="true"></i></span>
      <h2>{{ localTitle }}</h2>
      <p>{{ text }}</p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'popup-msg',
  props: {
    visible: {
      required: true,
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      required: true,
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info'
    }
  },
  data () {
    return {
      localTitle: ''
    }
  },
  watch: {
    type: function (val) {
      this.localTitle = this.title

      if (this.localTitle === '') {
        if (val === 'success') {
          this.localTitle = 'Success'
        } else if (val === 'info') {
          this.localTitle = 'Info'
        } else if (val === 'error') {
          this.localTitle = 'Error'
        } else if (val === 'danger') {
          this.localTitle = 'Warning'
        }
      }
    },
    title: function (val) {
      this.localTitle = val

      if (this.localTitle === '') {
        if (this.type === 'success') {
          this.localTitle = 'Success'
        } else if (this.type === 'info') {
          this.localTitle = 'Info'
        } else if (this.type === 'error') {
          this.localTitle = 'Error'
        } else if (this.type === 'danger') {
          this.localTitle = 'Warning'
        }
      }
    }
  },
  mounted () {
    this.localTitle = this.title

    if (this.localTitle === '') {
      if (this.type === 'success') {
        this.localTitle = 'Success'
      } else if (this.type === 'info') {
        this.localTitle = 'Info'
      } else if (this.type === 'error') {
        this.localTitle = 'Error'
      } else if (this.type === 'danger') {
        this.localTitle = 'Warning'
      }
    }
  },
  methods: {
    closePopupMsg () {
      this.$parent.closePopupMsg()
    }
  }
}
</script>



// WEBPACK FOOTER //
// PopupMsg.vue?179f5908